import BrandFunnel from './BrandFunnel';
import './BrandFunnel.scss';

export default BrandFunnel;
